// @ts-check

import Log from '../core/logging'
import Transform from '../core/transform'
import { sleep } from '../core/utilities'

const log = new Log()
// log.silent = false;
log.name = 'Visibility'

// function sleep (time) {
//     return new Promise((resolve) => setTimeout(resolve, time));
// }

export const show = function (dom, transition, cls) {
  dom.removeClass('hidden')

  Transform.transition(dom, `opacity ${transition}`)

  dom.style.opacity = 1
  dom.setStyle('visibility', 'visible')
  if (cls) {
    dom.addClass(cls)
  }
  return dom
}

export const hide = function (dom, transition, cls) {
  log.trace('hiding popup')

  // const updateTransition = function (ev) {
  //     log.trace("transition ended:", ev);
  //     dom.setStyle("visibility", "hidden");
  //     dom.addClass("hidden");
  //     if (cls) {
  //         dom.removeClass(cls);
  //     }
  //     log.trace("removing transitionend event");
  //     dom.removeEventListener(ev.type, updateTransition);
  // };

  // dom.addEventListener("transitionend", updateTransition, true);

  Transform.transition(dom, `opacity ${transition}`)

  dom.style.opacity = 0

  sleep(500).then(() => {
    dom.setStyle('visibility', 'hidden')
    dom.addClass('hidden')
    if (cls) {
      dom.removeClass(cls)
    }
  })
  // sleep(100).then(() => {});

  return dom
}

export const dimBackground = function () {
  if (document.getElement('div.pop-background')) {
    // need only one per page
    return document.getElement('div.pop-background')
  }

  const body = document.getElement('body')

  // TODO: determine if this is necessary
  body.addClass('no-scrolling')

  const el = document.createElement('div')
  el.setAttribute('class', 'pop-background high')
  body.appendChild(el)
  return el
}

export const removeBackground = function () {
  const bg = document.getElement('div.pop-background')
  if (bg) {
    bg.parentNode.removeChild(bg) // .dispose();

    // TODO: determine if this is necessary
    document.getElement('body').removeClass('no-scrolling')
  } else {
    log.trace('no dimmed background?')
  }
}

// export default { show, hide };
